import React from 'react';

import { getProductsByEmailMarketing } from '@/components/Containers/ProductsContainer';
import { FeatureComparator } from '@/components/Elements/FeatureComparator';
import { EmailMarketingProducts } from '@/components/Products';
import stepsFixtureEmailing from '@/components/Products/fixtures/marksEmail.json';
import { ProductTypes, UserProductTypes } from '@/types';

export type FeatureComparatorContainerProps = {
  className?: string;
  freemiumProduct: ProductTypes;
  products: ProductTypes[];
  userProducts?: UserProductTypes[] | undefined;
  onProductSelect: (product: ProductTypes) => void;
  onFreeProductSelect: (product: ProductTypes) => void;
  onRequestInfo: (product: ProductTypes) => void;
  publicPage?: boolean;
  userIsLogged: boolean;
};

export const FeatureComparatorContainer = ({
  className,
  freemiumProduct,
  products,
  userProducts,
  onProductSelect,
  onFreeProductSelect,
  onRequestInfo,
  publicPage,
  userIsLogged,
}: FeatureComparatorContainerProps) => {
  const getEmailMarketingSteps = () => stepsFixtureEmailing;
  const productsEmailMarketing = getProductsByEmailMarketing(products);

  return (
    <div className={className}>
      <EmailMarketingProducts
        freemiumProduct={freemiumProduct}
        products={productsEmailMarketing}
        steps={getEmailMarketingSteps()}
        onRequestInfo={onRequestInfo}
        onProductSelect={onProductSelect}
        onFreeProductSelect={onFreeProductSelect}
        userProducts={userProducts}
        userIsLogged={userIsLogged}
        showFeatures={false}
        stickyMode={true}
        publicPage={publicPage}
      />
      <FeatureComparator />
    </div>
  );
};
